export default "__VITE_ASSET__BTnjFHIK__"